module.exports = __webpack_public_path__ + "img/big_1_52.74090a58.png";